
const moment = require('moment') // https://github.com/brockpetrie/vue-moment
import _ from 'lodash'
// const axios = require('axios');
import axios from 'axios'
import config  from './config'

function getAttrs(obj, keys) {

  if (typeof keys == 'string' && keys.indexOf(',') >= 0)
    keys = keys.trim().split(/\s*,\s*/)

  return keys.reduce((t, p) => {t[p] = obj[p]; return t}, {})
}

/**
 * fromObj 의 값들을 toObj로 put 한다.
 * @param {Object} toObj
 * @param {Object} fromObj
 * @param {String|Array} keys 지정하지 않으면 fromObj의 모든 key
 * @return {Object} toObj toObj 그대로 반환
 */
function putAttrs(toObj, fromObj, keys) {

  if (!fromObj) {
    return toObj
  }

  if (!keys) {
    keys = Object.keys(fromObj)
  } else if (typeof keys == 'string' && keys.indexOf(',') >= 0) {
    keys = keys.trim().split(/\s*,\s*/)
  }

  if (keys) {
    keys.forEach(k=> toObj[k] = fromObj[k])
  }

  return toObj
}

function deepCopy(obj) {
  if (!obj) return {}
  return Object.entries(obj).reduce((t, [k,v]) => {t[k] = v; return t}, {})
}

function copyWithout(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0)
    continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  } return target;
}

/**
 * targetObj 의 value를 설정한다.
 *  targetObj = {listSize: 10, pageNo: 10, kword: ''}
 *  valueObj  = {pageNo: '5'}
 *  keyAndDefaultObj = {listSize: 10, pageNo: 1, kword: 'all'}
 * 결과
 *  targetObj = {listSize: 10, pageNo: 5, kword: 'all'}
 * @param {Object} targetObj 주로 search
 * @param {Object} valueObj 주로 $route.query
 * @param {Object} keyAndDefaultObj 주로 search_init
 */
function setAttrs(targetObj, valueObj, keyAndDefaultObj) {
  const keys = Object.keys(keyAndDefaultObj)
  keys.forEach(k=> {
    const defaultValue = keyAndDefaultObj[k]
    let v = valueObj[k]
    if (v === undefined || v === null   ) { v = defaultValue }

    targetObj[k] = v
  })
  return targetObj
}

function initAttr(obj, initObj) {
  if (!obj) return {}
  let ret = Object.entries(obj).reduce((t, [k,v]) => {
    t[k] = initObj[k] === undefined ? null : initObj[k];
    console.log("k = ", k, "t[k] = ", t[k])
    return t
  }, obj)

  return Object.entries(initObj).reduce((t, [k,v]) => {
    t[k] = initObj[k]
    return t
  }, obj)

}

function toForm(obj) {
  return Object.entries(obj).reduce((t, [k,v]) => { t.append(k, v); return t}, new FormData())
}

function toInt(value, defaultValue) {

  if (typeof value == 'number') return value;

  if (isEmpty(defaultValue)) defaultValue = 0;
  if (typeof value != 'string') return defaultValue;
  if (isEmpty(value)) return defaultValue;

  value = removeComma(value);

  return !isNaN(value) ? parseInt(value) : isEmpty(defaultValue) ? 0 : defaultValue;
}


function isNotEmpty(str) {
	return str !== null && str !== undefined && (""+str).length > 0;
}

function isEmpty(str) {
	return !isNotEmpty(str);
}

// 콤마 넣기
function comma(n) {
	if (isEmpty(n)) return "";
	var reg = /(^[+-]?\d+)(\d{3})/;
	n += '';
	while (reg.test(n))
		n = n.replace(reg, '$1' + ',' + '$2');
	return n;
}

// 콤마 빼기
function removeComma(str) {
	if (isEmpty(str)) return "";
	var reg = /^\$|,/g;
	return str.replace(reg, "");
}

// - 빼기
function removeHyphen(str) {
	if (isEmpty(str)) return "";
	var reg = /^\$|-/g;
	return str.replace(reg, "");
}

// 특정 자리에 - 넣기
function insertHyphen(str) {
  if (isEmpty(str)) return "";
  // if (!ed) ed = str.length
  // if (str.length < ed) return str;

  // return str.substring(0, st) + '-' + str.substring(st, ed)

  let ret = ''
  let idx = 0

  for(let i = 1; i < arguments.length; i++) {
    // console.log(" 1 = ",arguments[i])
    const length = arguments[i]
    if (idx > 0) ret += '-'
    ret += str.substring(idx, idx + length)
    idx += length;
  }
  if (idx > 0) ret += '-'
  ret += str.substring(idx, idx + 10000000)

  return ret
}

// 특정 자리에 : 넣기
function insertColon(str, st, ed) {
  if (isEmpty(str)) return "";
  if (!ed) ed = str.length
  if (str.length < ed) return str;

	return str.substring(0, st) + ':' + str.substring(st, ed) + ":" + str.substring(ed)
}


// 왼쪽부터 자르기
function left(str, idx) {
  if (isEmpty(str)) return "";
  return str.substring(0, idx);
}

// 오른쪽부터 자르기
function right(str, idx) {
  if (isEmpty(str)) return "";
  return str.substring(str.length, str.length-idx);
}

// 금액 컴마 및 절대값 반환
function absComma(value) {
  if (isEmpty(value)) return "";
  if (typeof value != 'number') return value;
	return comma(Math.abs(value))
}

export default {
  getAttrs, putAttrs, setAttrs, deepCopy, copyWithout, initAttr, toForm, removeHyphen, insertHyphen, insertColon,
  toInt,
  isNotEmpty,isEmpty,
  comma, removeComma,
  left, right,
  absComma,

  substring: function (str, st, ed) {
    try {
      return str.substring(st, ed);
    } catch (e) {
      return '';
    }
  },
  cloneObj: function (obj) {
    return Object.assign({}, obj);
  },
  findIndexByKey: function (array, key, value) { // 해당 리스트에서 원하는 값이 있는 row의 index 를 찾는다.
    if (!array) return -1
    var isEmptyValue = isEmpty(value) // value가 empty인가 ?
    for (var i = 0; i < array.length; i++) {
      var item = array[i];
      if (typeof item === 'object') {
        var v = item[key];
        if (isEmptyValue && isEmpty(v) || v === value)
          return i;
      }
    }
    return -1;
  },
  findArrayItem: function (array, key, value) {
    for(var i=0; i<array.length; i++) {
      if (array[i][key] == value)
        return array[i]
    }
    return null
  },
  removeListFindByKey: function (array, key, value) { // 해당 리스트에서 원하는 값이있는 키를 찾아서 삭제한다.. 성공시 true
    var idx = this.findIndexByKey(array, key, value);
    if (idx < 0) return false; // 찾는키가 없으면 아무것도 안한다.
    array.splice(idx, 1);
    return true;
  },

  /*
    멀티라인을 json객체로 변경
    makeJson(`
      text  | value
      번호  | a
      제목  | b
      작성일| c
    `, '|');
  */
 makeJson (data, delimiter="|") {
  var delimiter_reg = new RegExp('\\s*\\'+delimiter+'\\s*'); // delimiter 정규식
  var ar = data.trim().split(/\s*\n+\s*/); // newLine 기준 배열로 변환
  var keyNaemsAr = ar.shift().split(delimiter_reg) // 첫줄은 names 처리

  // align=center | nowrp = nowrap |  형태의 기본값 처리
  let headers = []
  keyNaemsAr.forEach(h => {
    const ar = h.split(/\s*=\s*/)
    let header = { key: ar[0] }
    if (ar.length > 1) {
      const v =ar[1]
      header.default = v === undefined ? undefined :
                       v == "true"  ? true  :
                       v == "false" ? false : v
    }
    headers.push(header)
  })

  // 첫 줄의 (default) 형태의 기본값 처리
  if (ar[0].indexOf('(default)') >= 0) {
    var values = ar.shift().split(delimiter_reg) // 첫줄은 names 처리
    headers.forEach((header,i) => {
      const k = header.key
      const v = values[i]
      if (v !== undefined) {
        header.default = v === undefined ? undefined :
                         v == "true"  ? true  :
                         v == "false" ? false :
                         v;
      }
    })
  }


  var ret = []; // 결과
  ar.forEach(line=>{
    var values = line.split(delimiter_reg) // delimiter 로 요소 나누기
    var newItem = {}
    headers.forEach((header,i) => {
      const k = header.key
      const d = header.default
      const v = values[i]
      const ret = v === undefined ? undefined :
                  v == "true"  ? true  :
                  v == "false" ? false :
//                     /^\d+$/.test(v) ? parseInt(v) :
                  v
      newItem[k] = (d !== undefined && this.isEmpty(ret)) ? d : ret

    }) // key 기준으로 무조건 설정 ( 값이 없어도 속성은 무조건 만든다. - 중요!! )
    ret.push(newItem);
  });

  return ret;
},

  /*
    샘플데이터 만들기
    T.makeSample("a,b,c,d", 10),
    T.makeSample("a|b|c|d".split("|"), 10),
  */
  makeSample (keys, count) {
    if (keys.indexOf(','))
      keys = keys.split(',');

    var ret = [];
    for (let i = 0; i < count; i++) {
      var item = {};
      for(const key of keys) {
        item[key] = (""+Math.random()).substring(2, 10)
      }
      ret.push(item);
    }
    return ret;
  },

  /*
    샘플데이터 만들기
    T.makeSample("a,b,c,d", 10),
    T.makeSample("a|b|c|d".split("|"), 10),
  */
 makeSampleTable (keys, count) {

    var ret = {};

    // key가 문자열로 들어온 경우 알아서 배열로 split

    if (typeof keys === "string" && keys.indexOf(',')) {
      keys = keys.split(',');
    }

    // 해더 만들기

    let headers = []
    keys.forEach((v,i) => {
      headers.push({
        text: v,
        value: 'k' + i
      });
    })
    ret.headers = headers;

    // 샘플 데이터 만들기
    let items = [];
    for (let i = 1; i < count; i++) {
      var item = {};
      for (const i in keys) {
        item['k' + i] = (""+Math.random()).substring(2, 10)
      }
      items.push(item);
    }
    ret.items = items;

    // 페이지네이션
    ret.page = {};

    return ret;
  },

  /*
    랜덤 문자열을 만든다.
  */
  random(characters, length) {
    var result           = ''
    var charactersLength = characters.length
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  },

  az : "abcdefghijklmnopqrstuvwxyz",
  AZ : "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
  NU : "0123456789",

  randomAZ(length) { return this.random(this.AZ, length)},

  now(format = 'YYYY-MM-DD') {
    return moment().format(format)
  },

  makeUrlQueryString(obj) {
    return Object.keys(obj)
          .map(v => `${v}=${encodeURIComponent(obj[v])}`)
          .join('&')
  },

  log: console.log,

  toggle(obj, name) {
    let map = {...obj}
    map[name] = !map[name]
    return map
  },

  isNew(dateStr, days = 7) {
    return moment().diff(moment(dateStr),'day') <= days
  },

  highlight(words, query) { //  {{{ 'foo' | highlight 'fo' }}}
    if (query == null || query == '') return words;
    return words.replace(query, '<span class="highlight">' + query + '</span>')
  },

  // flag(당일-now, 1개월 전-1m, 6개월 전-6m, 1년 전-1y)에 따라 날짜 반환
  doSetSearchDt(flag,format='YYYY-MM-DD') {
    // 당일
    if (flag == "now") {
      return moment().format(format)
    // 1개월(1m), 6개월(6m), 1년(1y)
    } else {
      return moment().subtract(left( flag, 1)
                             , right(flag, 1) == 'm' ? 'months' : 'year')
                              .format(format)
    }

  },

  money: {
    decimal: ',',
    thousands: ',',
    prefix: '',
    suffix: '',
    precision: 0,
    masked: false /* doesn't work with directive */
  },

  compactObj(obj) { // 객체에서 undefined 또는 빈값은 제외한다.
    return _.omitBy(obj, v=>v === undefined || v == "" || v == 0)
  },

  /**
  * 일반적인 http get
  */
  httpGet(path, params, cbRet, cbErr, cbFinal) {
    // Vue.$http.get(Vue.$api + path, { params })
    axios.get(config.API_PATH + path, { params : { _r : Math.random(), ...params } })
      .then(cbRet)
      .catch(e=> {
        cbErr && cbErr(e)
      })
      .then(()=>{
        cbFinal && cbFinal()
      })
  },

  defaultObj(obj) {
    if (obj === undefined || obj === null) return {}
    if (obj.constructor == Array ) return {}
    if (obj.constructor == Object ) return obj;
    return obj;
  },

  trim(str) {
    return (str === undefined || str == null) ? "" : str.replace(/(^\s*)|(\s*$)/g, "");
  },

  wrap유한(str) {
    if (str === undefined || str == null) return ""
    if (str.indexOf('(유한)') >= 0) return "[" + str + "]"
    return "(" + str + ")"
  },

  codeText(code, value) {
    return code[_.findIndex(code, { 'value': value })].text
  },

  /* value가 null이거나 undefined 이면 defaultValue를 반환한다 */
  isNull(value, defaultValue) {
    if (value == null || value === undefined) return defaultValue
    return value
  },

  /*
    해당 배열의 모든 요소에 해당 값들을 설정한다.
    let items = [{a:0},{b:0},{c:0}]
    let ret = arraySetAll(items, {chk: true})
    ==> [{a:0,chk:true},{b:0,chk:true},{c:0,chk:true}]
  */
  arraySetAll(items, map) {
    if (_.isEmpty(items)) return items
    items.forEach(item=>_.forEach(map,(k,v) => { item[v]=k; return true }))
    return items
  },

  f_org_br(str) {
    if (_.isEmpty(str)) return ""
    return str.replace(/([\\(\\[])/, "<br/>$1")
  },

  nl_to_br(str) {
    if (_.isEmpty(str)) return ""
    return str.replace(/[\r\n]+/g, "<br/>\n")
  },

  // code 이름 가져오기
  // T.code(code.B40000, dbitem.viacancelclsf, 'text', '')
  // T.code(code.B40000, dbitem.viacancelclsf) // 또는 그냥
  code(codeArray, value, getField = 'text', defaultValue = '') {
    if (_.isEmpty(codeArray)) return ''
    const item = _.find(codeArray, v=>v.value == value)
    return _.get(item, getField, defaultValue)
  },

  isNullOrUndefined(obj) {
    return obj === null || obj === undefined
  },

  /**
   * 지정 객체의 모든 값들을 해제한다.
   * let item = {a: 'aa', b: 'bb'}
   * attrClear(item) // {a: null, b: null}
   * attrClear(item, {a: '11'}) // {a: '11', b: null}
   * 반환 : item 원본을 그대로 반환한다.
   */
  attrClear(item, clearValue = null) {
    if (this.isNullOrUndefined(item)) return {} // item 없으면.. 채이닝 오류방지를 위해서 빈 obj 반환
    for(const key in item) {
      item[key] = clearValue
    }
    return item
  },

  /**
   * 객체를 설정한다
   * item = {...item, a:1, b:2} 이렇게 하는것과 차이점은
   * item 은 그대로 유지한다는 것이다.
   * 반환 : item 그대로.
   */
  attrSet(item, attrItem) {
    if (this.isNullOrUndefined(item)) return {} // item 없으면.. 채이닝 오류방지를 위해서 빈 obj 반환
    if (this.isNullOrUndefined(attrItem)) return item // attrItem 이 없으면 일 안함
    for(const key in attrItem) {
      item[key] = attrItem[key]
    }
    return item
  },

  /**
   * setClear 하고 setAttr 을 같이 실행한다.
   */
  attrClearSet(item, clearValue, attrItem) {
    return this.attrSet(this.attrClear(item, clearValue), attrItem)
  },

  /**
   * Number 컬럼의 디비 업데이트를 위해서 '' 인 항목은 null 로 변경한다.
   * @param {Object} item
   * @param {Array} attrs
   */
  attrEmptyNumberToNull(item, attrs) {
    if (_.isEmpty(attrs) || _.isEmpty(item)) return item
    for(const key of attrs) {
      if (item[key] != null && _.isEmpty(item[key])) { // null 이 아닌데 비어 있으면
        item[key] = null // null 로 설정
      }
    }
    return item
  },

  /**
   * 값이 비어있을때 defaultValue 를 반환
   * @param {object} val
   * @param {object} defaultValue
   */
  defaultEmpty(val, defaultValue) {
    if (val == null || val === undefined) return defaultValue
    if (typeof val == 'string') {
      if (val.trim().length < 1) return defaultValue
    }
    return val
  },

  /**
   * 키워드가 안에 있나 확인
   * @param {*} targetString
   * @param {*} keyword
   */
  contains(targetString, keyword) {
    if (this.isNullOrUndefined(targetString) || this.isNullOrUndefined(keyword) ) return false
    return targetString.indexOf(keyword) >= 0
  },

}